import type { TrashEntityType } from "@studyhub/shared/contracts/trash";
import { Skeleton } from "@studyhub/ui/components/skeleton";
import { SectionHeader } from "@studyhub/ui/components/studyhub/section-header";
import { IconTrash } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LIST_PAGE_SHELL } from "@/components/shared/entity-list";
import {
	SectionIntro,
	SectionIntroReopen,
	useSectionIntro,
} from "@/components/shared/section-intro";
import { useUnifiedTrashList } from "@/components/trash/_api";
import { UnifiedTrashList } from "@/components/trash/trash-list";
import { useRefetchOnOnline } from "@/hooks/use-refetch-on-online";

export const Route = createFileRoute("/trash")({
	component: UnifiedTrashPage,
});

function UnifiedTrashPage(): React.ReactElement {
	const { t } = useTranslation("trash");
	const intro = useSectionIntro("trash");
	const [entityType, setEntityType] = useState<TrashEntityType | undefined>();
	const query = useUnifiedTrashList(entityType);
	useRefetchOnOnline(() => query.refetch(), query.isError);
	const items = query.data?.items ?? [];

	return (
		<div className={LIST_PAGE_SHELL}>
			<SectionHeader
				icon={<IconTrash />}
				category="time"
				title={t("title")}
				description={t("subtitle", { count: items.length })}
				actions={<SectionIntroReopen intro={intro} />}
			/>

			{/* Баннер-объяснение раздела: текст из манифеста модуля, состояние
			    «свёрнут» — серверное (см. section-intro.tsx). */}
			<SectionIntro intro={intro} />

			{query.isLoading ? (
				<div className="flex flex-col gap-stack" aria-busy="true">
					{Array.from({ length: 4 }, (_, i) => (
						<Skeleton key={`trash-${i}`} className="h-14 w-full rounded-[var(--radius-card)]" />
					))}
				</div>
			) : (
				<UnifiedTrashList
					items={items}
					entityType={entityType}
					onEntityTypeChange={setEntityType}
					listError={query.isError}
				/>
			)}
		</div>
	);
}
